exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.course[data-v-40fb93f8] {\n}\n.chapter[data-v-40fb93f8] {\n    border-top: 1px solid #aaaaaa;\n}\n", ""]);

// exports
